import { BasicModel } from '../basic/basic.model';
import { SocieteModel } from '../simple-types/societe.model';
import { DroitModel } from './droit.model';

export class UtilisateurModel extends BasicModel {
    idSociete: number;
    societe: SocieteModel;
    // max length 30
    nom: string;
    // max length 30
    prenom: string;
    // max 50
    email: string;
    // max length 20
    tel: string;
    actif: boolean;

    droits: DroitModel[];
    // password: string;
}
